export const TEXT_KEYS = [
	'GET_STARTED',
	'VERIFY_POPUP_DESCRIPTION_NEW',
	'VERIFY_POPUP_DENY_BUTTON',
	'CONTINUE_WITH',
	'CPR_ERROR',
	'GENERAL_ERROR',
	'SESSION_NOT_FOUND',
	'VERIFICATION_NOT_POSSIBLE'
];

export const END_POINTS = {
	configs: '/getUrlAndParameters',
	validate: '/verifyAndLogin'
};
